import { ParticipantList } from './ParticipantList';

interface Participant {
  id: string;
  conversation_id: string;
  user_id: string;
  role: 'owner' | 'member' | 'guest';
  display_name: string | null;
  avatar_url: string | null;
  alias: string | null;
  created_at: string;
}

interface ParticipantSidebarProps {
  participants: Participant[];
  loading: boolean;
  currentUserId?: string;
  onRemoveParticipant: (userId: string) => Promise<void>;
  onClose: () => void;
}

export function ParticipantSidebar({
  participants,
  loading,
  currentUserId,
  onRemoveParticipant,
  onClose,
}: ParticipantSidebarProps) {
  return (
    <aside
      className="w-64 bg-slate-800 border-l border-slate-700 flex-shrink-0 overflow-y-auto"
      data-testid="participant-panel"
    >
      <div className="p-3 border-b border-slate-700 flex items-center justify-between">
        <h3 className="text-sm font-semibold text-white">Participants ({participants.length})</h3>
        <button
          onClick={onClose}
          className="p-1 text-slate-400 hover:text-white transition-colors"
          aria-label="Close participant panel"
          data-testid="close-participant-panel"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>
      <ParticipantList
        participants={participants}
        loading={loading}
        currentUserId={currentUserId}
        onRemoveParticipant={onRemoveParticipant}
      />
    </aside>
  );
}
